import React, { useState } from "react";
import axios from "axios";
import API_URL from "../config";
//import cloudinary from '../cloudinary-config/cloudinary.js';  

export default function TrackOrder() {
  const [phone, setPhone] = useState("");
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searched, setSearched] = useState(false);

  const handleTrack = async () => {
    if (!phone) return;
    setLoading(true);
    setSearched(true);
    try {
    const res = await axios.get(`${API_URL}/api/track/${phone}`);
      setOrders(res.data);
    } catch (err) {
      setOrders([]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');

        .track-wrapper * {
          box-sizing: border-box;
          font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
        }

        .track-wrapper {
          min-height: 100vh;
          background-color: #f9fafb;
          padding: 60px 20px;
          color: #111827;
        }

        .track-container {
          max-width: 680px;
          margin: 0 auto;
        }

        .track-header {
          margin-bottom: 40px;
        }

        .track-title {
          font-size: 32px;
          font-weight: 700;
          letter-spacing: -0.02em;
          margin-bottom: 8px;
        }

        .track-subtitle {
          color: #6b7280;
          font-size: 15px;
        }

        /* Input Section */
        .track-search-row {
          display: flex;
          gap: 12px;
          margin-bottom: 40px;
        }

        .track-input {
          flex: 1;
          padding: 16px 20px;
          font-size: 15px;
          border: 1px solid #e5e7eb;
          border-radius: 12px;
          background: #ffffff;
          outline: none;
          transition: all 0.2s ease;
          box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
        }

        .track-input:focus {
          border-color: #f43f72;
          box-shadow: 0 0 0 4px rgba(244, 63, 114, 0.1);
        }

        .track-btn {
          background: #f43f72;
          color: #ffffff;
          border: none;
          padding: 0 32px;
          border-radius: 12px;
          font-size: 15px;
          font-weight: 600;
          cursor: pointer;
          transition: background 0.2s ease;
          box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
        }

        .track-btn:hover {
          background: #e02860;
        }

        /* Order Cards */
        .track-card {
          background: #ffffff;
          border: 1px solid #e5e7eb;
          border-radius: 16px;
          padding: 32px;
          margin-bottom: 24px;
          box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.02), 0 2px 4px -2px rgba(0, 0, 0, 0.02);
        }

        .track-card-header {
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          border-bottom: 1px solid #f3f4f6;
          padding-bottom: 20px;
          margin-bottom: 20px;
        }

        .track-id {
          font-size: 18px;
          font-weight: 700;
          color: #111827;
        }

        .track-date {
          color: #6b7280;
          font-size: 14px;
          margin-top: 4px;
        }

        .track-status {
          background: #fdf2f5;
          color: #f43f72;
          padding: 6px 12px;
          border-radius: 20px;
          font-size: 12px;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.05em;
        }

        /* Items */
        .track-item {
          display: flex;
          justify-content: space-between;
          padding: 12px 0;
          font-size: 15px;
          color: #374151;
        }

        .track-item-qty {
          color: #9ca3af;
          font-size: 13px;
          margin-left: 8px;
        }

        .track-item-price {
          font-weight: 500;
        }

        /* Total */
        .track-total-row {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 24px;
          padding-top: 24px;
          border-top: 1px dashed #e5e7eb;
        }

        .track-total-label {
          font-size: 15px;
          font-weight: 500;
          color: #6b7280;
        }

        .track-total-value {
          font-size: 24px;
          font-weight: 700;
          color: #111827;
        }

        .track-empty {
          text-align: center;
          padding: 60px 20px;
          background: #ffffff;
          border-radius: 16px;
          border: 1px dashed #d1d5db;
          color: #6b7280;
          font-size: 15px;
        }

        @media (max-width: 600px) {
          .track-search-row {
            flex-direction: column;
          }
          .track-btn {
            padding: 16px;
          }
        }
      `}</style>

      <div className="track-wrapper">
        <div className="track-container">
          
          <div className="track-header">
            <h1 className="track-title">Track Your Order</h1>
            <p className="track-subtitle">Enter the phone number associated with your purchase.</p>
          </div>

          <div className="track-search-row">
            <input
              type="text"
              placeholder="Enter your phone number..."
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              className="track-input"
            />
            <button onClick={handleTrack} className="track-btn">
              {loading ? "Searching..." : "Track Order"}
            </button>
          </div>

          <div>
            {orders.length > 0 ? (
              orders.map((order) => (
                <div key={order._id} className="track-card">
                  
                  <div className="track-card-header">
                    <div>
                      <div className="track-id">Order #{order._id.slice(-8).toUpperCase()}</div>
                      {/* Exact time and date restored here */}
                      <div className="track-date">
                        {new Date(order.createdAt).toLocaleString()}
                      </div>
                    </div>
                    <div className="track-status">{order.status}</div>
                  </div>

                  <div className="track-items-list">
                    {order.items.map((item, i) => (
                      <div key={i} className="track-item">
                        <div>
                          {item.name} <span className="track-item-qty">x {item.quantity}</span>
                        </div>
                        <div className="track-item-price">{item.price * item.quantity} AED</div>
                      </div>
                    ))}
                  </div>

                  <div className="track-total-row">
                    <span className="track-total-label">Total Amount</span>
                    <span className="track-total-value">{order.total} AED</span>
                  </div>

                </div>
              ))
            ) : (
              searched && !loading && (
                <div className="track-empty">
                  No orders found for this number. Please check and try again.
                </div>
              )
            )}
          </div>

        </div>
      </div>
    </>
  );
}